import { render, staticRenderFns } from "./Block_8.vue?vue&type=template&id=353060ec&scoped=true&"
import script from "./Block_8.vue?vue&type=script&lang=js&"
export * from "./Block_8.vue?vue&type=script&lang=js&"
import style0 from "./Block_8.vue?vue&type=style&index=0&id=353060ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353060ec",
  null
  
)

export default component.exports